import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Winningdubai() {
  return (
    <section className="winning_dubai p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>Why Teams Choose Our IT Staff Augmentation Services?</h2>
          </Col>
          <Col xs={12} md={6} lg={5} className="offset-lg-1">
            <p>
              Staff augmentation given IT teams that extra boost required to
              maintain optimal productivity during the growth – that too with
              more flexibility and less hassle. See yourself:
            </p>
          </Col>

          <Col xs={12} md={12} lg={12} className="mt-4">
            <StaticImage
              src="../../../images/solution/it-staff/it_table.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1603}
              height={992}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Winningdubai;
